import React, {
  useState,
  useEffect,
  FunctionComponent,
} from "react";
import Topbar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import { CUSTOM_BUTTONS_COLUMNS } from "../../Values/tables";

import {
  filterStatus,
  searchAPIItem,
} from "../../Values/utils";

import CustomTable from "../../Components/CustomTable/CustomTable";
// import ApiModal from '../../Components/Modals/ApiModal/ApiModal';
import {
  fetchApi,
  fetchCustomButtons,
} from "../../Services/organizations";
import AddCustomButtonModal from "../../Components/Modals/AddCustomButtonModal/AddCustomButtonModal";

type props = {
  history: any;
  organizationId: any;
};

const CustomButtonPanel: FunctionComponent<props> = ({
  history,
  organizationId,
}) => {
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<
    any[] | undefined
  >(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>(
    []
  );
  const [selectedRowsData, setSelectedRowsData] = useState<
    any[]
  >([]);
  const [customButtonModal, setCustomButtonModal] =
    useState(false);
  const [customButtons, setCustomButtons] = useState<
    any[] | undefined
  >(undefined);
  const [status, setStatus] = useState("ALL");
  const [temporaryData, setTemporaryData] = useState<any[]>(
    []
  );
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState();

  useEffect(() => {
    if (organizationId) {
      fetchCustomButtons(organizationId, (val) =>
        setCustomButtons(val)
      );
    }
  }, [organizationId]);

  useEffect(() => {
    customButtons?.forEach((item: any) => {
      item.parameters = JSON.stringify(item.parameters);
      item.headers = JSON.stringify(item.headers);
      // item.created_at = item.created_at.toDate();
    });

    setFilterData(customButtons);
  }, [customButtons]);

  return (
    <>
      <div className={commonStyle.topBar}>
        <Topbar
          history={history}
          title={"Add Custom Button"}
          path={"/addUsers"}
          filterText="Status"
          show={false}
          setCustomButtonModal={(data) =>
            setCustomButtonModal(data)
          }
        />
      </div>
      <div className={commonStyle.parent}>
        <CustomTable
          tableColumns={CUSTOM_BUTTONS_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="Custom Button"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) =>
            setSelectedRowsData(data)
          }
          // setSearchedItem={(val) => setsearchQuery(val)}
          // setApiModal={(data) => setApiModal(data)}
          // setApiEdit={(data) => setEdit(data)}
          // setApiData={(data) => setEditData(data)}
        />
      </div>
      {customButtonModal === true && (
        <AddCustomButtonModal
          open={customButtonModal}
          close={() => setCustomButtonModal(false)}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
  };
};
export default connect(mapStateToProps)(CustomButtonPanel);
